import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, ChangeDetectionStrategy} from "@angular/core";
import { OptionToCloseCell } from "./option-to-close-cell.component";
import { AppService } from "@irb/app.service";
import { IrbClientsEvents } from "@irb/irb-clients/irb-clients.events";

@Component({ standalone: false,
    selector: 'option-to-close-cell-editor',
    templateUrl: './option-to-close-cell-renderer.html',
    styleUrls: ["./option-to-close-cell-renderer.scss"],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class OptionToCloseCellRenderer extends OptionToCloseCell implements ICellRendererAngularComp {
    disabled: boolean;

    constructor(private as: AppService) {
        super();
    }
    
    agInit(params: any): void {
        this.params = params;
        this.componentParent = this.params.context.componentParent;
        this.params.disabled = (typeof this.params.isDisabled !== "undefined") ? this.params.isDisabled : false;
        this.disabled = (typeof this.params.disabled !== "undefined") ? this.params.disabled : false;
        this.load();
    }

    refresh(): boolean {
        return true;
    }

    onOptionChange() {
        if (this.selectedValue.value === 'VIEW_CHAIN' || this.selectedValue.value === 'OPTION_CHAIN') {
            const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
            this.componentParent.editedRowIndex = rowIndex;

            this.as.fireEvent(IrbClientsEvents.SHOW_OPTION_CHAINS_DIALOG, {
                data: {
                    action: 'BUY_TO_COVER', 
                    underlyingSymbol: this.params.data.underlyingSymbol, 
                    chainType: this.getChainType(),
                    isChainTypeDisable: false,
                    isTrayVisible: false
                }
            });

            this.selectedValue = this.options[0];
            this.dropdownFilter.setValue(this.selectedValue);
        } else {
            this.params.data.optionSelectionMode = this.selectedValue.value;
            this.params.data.optionSymbol = null;
            this.componentParent.loadGrid();
        }
    }

    getChainType() {
        let chainType: string = "ALL";
        if (this.params.data.optionSelectionMode) {
            switch(this.params.data.optionSelectionMode) {
                case 'ALL_CALLS':
                    chainType = "CALL";
                    break;
                case 'ALL_PUTS':
                    chainType = "PUT";
                    break;
            }
        }
        return chainType;
    }
}
